module.exports = __webpack_public_path__ + "static/media/compass-normal.1fd9eae7.svg";